/** UTM source value stamped on creator-site offer links for checkout attribution. */
export const CREATOR_SITE_UTM_SOURCE = 'creator_site';

export const CREATOR_SITE_UTM_MEDIUM = 'website';

export const CREATOR_SITE_UTM_CAMPAIGN = 'creator_presence';

/** Click-to-purchase attribution window for analytics revenue rollups. */
export const CREATOR_SITE_OFFER_ATTRIBUTION_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

export type CreatorSiteOfferAttributionContext = {
  username?: string;
  sectionId?: string;
  pageSlug?: string;
};

export function buildCreatorSiteOfferHref(
  offerSlug: string,
  context?: CreatorSiteOfferAttributionContext,
): string {
  const params = new URLSearchParams();
  params.set('utm_source', CREATOR_SITE_UTM_SOURCE);
  params.set('utm_medium', CREATOR_SITE_UTM_MEDIUM);
  params.set('utm_campaign', CREATOR_SITE_UTM_CAMPAIGN);
  if (context?.username?.trim()) {
    params.set('utm_content', context.username.trim().toLowerCase());
  }
  if (context?.sectionId?.trim()) {
    params.set('cp_section', context.sectionId.trim());
  }
  if (context?.pageSlug?.trim() && context.pageSlug.trim() !== 'home') {
    params.set('cp_page', context.pageSlug.trim());
  }
  const query = params.toString();
  return query ? `/offers/${offerSlug}?${query}` : `/offers/${offerSlug}`;
}

export function readCreatorSiteOrderAttribution(metadata: unknown): {
  fromCreatorSite: boolean;
  sectionId?: string;
  pageSlug?: string;
  username?: string;
} {
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) {
    return { fromCreatorSite: false };
  }
  const record = metadata as Record<string, unknown>;
  const utmSource =
    typeof record.utm_source === 'string'
      ? record.utm_source
      : typeof record.utmSource === 'string'
        ? record.utmSource
        : null;
  const fromCreatorSite = utmSource === CREATOR_SITE_UTM_SOURCE;
  return {
    fromCreatorSite,
    sectionId:
      typeof record.cp_section === 'string'
        ? record.cp_section
        : typeof record.cpSection === 'string'
          ? record.cpSection
          : undefined,
    pageSlug:
      typeof record.cp_page === 'string'
        ? record.cp_page
        : typeof record.cpPage === 'string'
          ? record.cpPage
          : undefined,
    username:
      typeof record.utm_content === 'string'
        ? record.utm_content
        : typeof record.utmContent === 'string'
          ? record.utmContent
          : undefined,
  };
}
